// extracted by mini-css-extract-plugin
module.exports = {"navbar":"styles_navbar__Xc3mg","pageContent":"styles_pageContent__VLAU5","menuLinkItem":"styles_menuLinkItem__1M5ZC"};